// extracted by mini-css-extract-plugin
module.exports = {"section1Container":"Section1_section1Container__sEezl","itemContainer":"Section1_itemContainer__EGDK3","itemRow":"Section1_itemRow__hAvXn","item":"Section1_item__Q18k0"};